module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-2021-5.a36ae876.jpg";